import { useSelector } from 'react-redux'
import Accordion from '../../../../../../UI/Accordion/Accordion'
import ValueInput from '../../helperElements/ValueInput'
import props from '../../../../../../../redux/props'
import {
  PrebuildArbeitstagSubType,
  PrebuildEinzelarbeitSubType,
  PrebuildMeetingGroesseBesprechungSubType,
  PrebuildMeetingGroesseCoworkingSubType,
  PrebuildType,
} from '../../../../../../../types/Survey/Element'
import { ConceptValues } from '../../../../../../../types/Survey/Analysis/Concept'

type Props = {
  values: ConceptValues
  updateValue?: (key: any) => (value: any) => void
}

const AdditionalConfiguration: React.FC<Props> = ({ values, updateValue }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  const items = [
    {
      key: 'additionalConfiguration',
      title: t.survey.analysis.concept.additionalConfiguration.title,
      content: (
        <div>
          <div>{t.survey.analysis.calculation.values.generic.headline}</div>
          <div className="flex flex-col gap-1">
            <ValueInput
              label={t.survey.configuration.factor.einzelbueroQM}
              value={values.factor.einzelbueroQM.value}
              originalValue={values.factor.einzelbueroQM.originalValue}
              onChange={updateValue(`factor.einzelbueroQM.value`)}
              suffix={t.generic.squareMeterSuffix}
              decimal
            />
          </div>
          <div>{t.survey.analysis.calculation.values.arbeitstag.headline}</div>
          <div className="flex flex-col gap-1">
            {Object.keys(PrebuildArbeitstagSubType).map((type) => (
              <ValueInput
                key={type}
                label={t.survey.prebuildType.types[type]}
                value={values.factor.arbeitstagPercentage[type].value}
                originalValue={values.factor.arbeitstagPercentage[type].originalValue}
                onChange={updateValue(`factor.arbeitstagPercentage.${type}.value`)}
                suffix={t.generic.percent}
                decimal
              />
            ))}
          </div>
          <div>{t.survey.analysis.calculation.values.einzelarbeit.headline}</div>
          <div className="flex flex-col gap-1">
            {Object.keys(PrebuildEinzelarbeitSubType).map((type) => (
              <div className="flex flex-col gap-1" key={type}>
                <ValueInput
                  key={type}
                  label={`${t.survey.prebuildType.types[type]} - %`}
                  value={values.factor.einzelarbeitPercentage[type].value}
                  originalValue={values.factor.einzelarbeitPercentage[type].originalValue}
                  onChange={updateValue(`factor.einzelarbeitPercentage.${type}.value`)}
                  suffix={t.generic.percent}
                  decimal
                />
                <ValueInput
                  label={`${t.survey.prebuildType.types[type]} - QM`}
                  value={values.factor.einzelarbeitQM[type].value}
                  originalValue={values.factor.einzelarbeitQM[type].originalValue}
                  onChange={updateValue(`factor.einzelarbeitQM.${type}.value`)}
                  suffix={t.generic.squareMeterSuffix}
                  decimal
                />
                <ValueInput
                  label={`${t.survey.prebuildType.types[type]} - Arbeitsplätze`}
                  value={values.factor.arbeitsplatz[PrebuildType.EINZELARBEIT][type].value}
                  originalValue={values.factor.arbeitsplatz[PrebuildType.EINZELARBEIT][type].originalValue}
                  onChange={updateValue(`factor.arbeitsplatz.${[PrebuildType.EINZELARBEIT]}.${type}.value`)}
                  suffix={t.generic.amountSuffix}
                  decimal
                />
              </div>
            ))}
            <div>{t.survey.analysis.calculation.values.meetingGroesseBesprechung.headline}</div>
            {Object.keys(PrebuildMeetingGroesseBesprechungSubType).map((type) => (
              <div className="flex flex-col gap-1" key={type}>
                <ValueInput
                  key={type}
                  label={`${t.survey.prebuildType.types[type]} - %`}
                  value={values.factor.meetingGroesseBesprechungPercentage[type].value}
                  originalValue={values.factor.meetingGroesseBesprechungPercentage[type].originalValue}
                  onChange={updateValue(`factor.meetingGroesseBesprechungPercentage.${type}.value`)}
                  suffix={t.generic.percent}
                  decimal
                />
                <ValueInput
                  label={`${t.survey.prebuildType.types[type]} - QM`}
                  value={values.factor.meetingGroesseBesprechungQM[type].value}
                  originalValue={values.factor.meetingGroesseBesprechungQM[type].originalValue}
                  onChange={updateValue(`factor.meetingGroesseBesprechungQM.${type}.value`)}
                  suffix={t.generic.squareMeterSuffix}
                  decimal
                />
                <ValueInput
                  label={`${t.survey.prebuildType.types[type]} - Arbeitsplätze`}
                  value={values.factor.arbeitsplatz[PrebuildType.MEETING_GROESSE_BESPRECHUNG][type].value}
                  originalValue={values.factor.arbeitsplatz[PrebuildType.MEETING_GROESSE_BESPRECHUNG][type].originalValue}
                  onChange={updateValue(`factor.arbeitsplatz.${[PrebuildType.MEETING_GROESSE_BESPRECHUNG]}.${type}.value`)}
                  suffix={t.generic.amountSuffix}
                  decimal
                />
              </div>
            ))}
            <div>{t.survey.analysis.calculation.values.meetingGroesseCoworking.headline}</div>
            {Object.keys(PrebuildMeetingGroesseCoworkingSubType).map((type) => (
              <div className="flex flex-col gap-1" key={type}>
                <ValueInput
                  key={type}
                  label={`${t.survey.prebuildType.types[type]} - %`}
                  value={values.factor.meetingGroesseCoworkingPercentage[type].value}
                  originalValue={values.factor.meetingGroesseCoworkingPercentage[type].originalValue}
                  onChange={updateValue(`factor.meetingGroesseCoworkingPercentage.${type}.value`)}
                  suffix={t.generic.percent}
                  decimal
                />
                <ValueInput
                  label={`${t.survey.prebuildType.types[type]} - QM`}
                  value={values.factor.meetingGroesseCoworkingQM[type].value}
                  originalValue={values.factor.meetingGroesseCoworkingQM[type].originalValue}
                  onChange={updateValue(`factor.meetingGroesseCoworkingQM.${type}.value`)}
                  suffix={t.generic.squareMeterSuffix}
                  decimal
                />
                <ValueInput
                  label={`${t.survey.prebuildType.types[type]} - Arbeitsplätze`}
                  value={values.factor.arbeitsplatz[PrebuildType.MEETING_GROESSE_COWORKING][type].value}
                  originalValue={values.factor.arbeitsplatz[PrebuildType.MEETING_GROESSE_COWORKING][type].originalValue}
                  onChange={updateValue(`factor.arbeitsplatz.${[PrebuildType.MEETING_GROESSE_COWORKING]}.${type}.value`)}
                  suffix={t.generic.amountSuffix}
                  decimal
                />
              </div>
            ))}
          </div>
        </div>
      ),
    },
  ]

  return (
    <div className="mt-3">
      <Accordion items={items} invert />
    </div>
  )
}

export default AdditionalConfiguration
